"use strict";

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.isVerticalTouchmoveDetected = exports.getFadeoutAnimationPosition = exports.getFadeoutAnimationIndex = exports.getSwipeTouchendIndex = exports.getSwipeTouchendPosition = exports.getSwipeTransformationCursor = exports.getTransformationItemIndex = exports.getSwipeShiftValue = exports.getItemCoords = exports.getIsLeftDirection = exports.shouldRecalculateSwipePosition = exports.getSwipeLimitMax = exports.getSwipeLimitMin = exports.shouldCancelSlideAnimation = exports.shouldRecalculateSlideIndex = exports.getUpdateSlidePositionIndex = exports.getActiveIndex = exports.getStartIndex = exports.getShiftIndex = void 0;
var getShiftIndex = function (e, t) {
    return (e = void 0 === e ? 0 : e) + (t = void 0 === t ? 0 : t);
  },
  getStartIndex = (exports.getShiftIndex = getShiftIndex, function (e, t) {
    if (void 0 === e && (e = 0), t = void 0 === t ? 0 : t) {
      if (t <= e) return t - 1;
      if (0 < e) return e;
    }
    return 0;
  }),
  getActiveIndex = (exports.getStartIndex = getStartIndex, function (e) {
    var t = e.startIndex,
      t = void 0 === t ? 0 : t,
      i = e.itemsCount,
      e = e.infinite;
    return void 0 !== e && e ? t : (0, exports.getStartIndex)(t, void 0 === i ? 0 : i);
  }),
  getUpdateSlidePositionIndex = (exports.getActiveIndex = getActiveIndex, function (e, t) {
    return e < 0 ? t - 1 : t <= e ? 0 : e;
  }),
  shouldRecalculateSlideIndex = (exports.getUpdateSlidePositionIndex = getUpdateSlidePositionIndex, function (e, t) {
    return e < 0 || t <= e;
  }),
  shouldCancelSlideAnimation = (exports.shouldRecalculateSlideIndex = shouldRecalculateSlideIndex, function (e, t) {
    return e < 0 || t <= e;
  }),
  getSwipeLimitMin = (exports.shouldCancelSlideAnimation = shouldCancelSlideAnimation, function (e, t) {
    var i = e.itemsOffset,
      e = e.transformationSet,
      e = void 0 === e ? [] : e,
      o = t.infinite,
      t = t.swipeExtraPadding;
    return o ? (e[void 0 === i ? 0 : i] || {}).position : (o = (e[0] || {}).width, Math.min(void 0 === t ? 0 : t, void 0 === o ? 0 : o));
  }),
  getSwipeLimitMax = (exports.getSwipeLimitMin = getSwipeLimitMin, function (e, t) {
    var i = t.infinite,
      t = t.swipeExtraPadding,
      t = void 0 === t ? 0 : t,
      o = e.itemsCount,
      n = e.itemsOffset,
      r = e.itemsInSlide,
      r = void 0 === r ? 1 : r,
      e = e.transformationSet,
      e = void 0 === e ? [] : e;
    return i ? (e[(void 0 === o ? 1 : o) + (0, exports.getShiftIndex)(r, void 0 === n ? 0 : n)] || {}).position || 0 : (0, exports.getItemCoords)(-r, e).position + t;
  }),
  shouldRecalculateSwipePosition = (exports.getSwipeLimitMax = getSwipeLimitMax, function (e, t, i) {
    return -t <= e || Math.abs(e) >= i;
  }),
  getIsLeftDirection = (exports.shouldRecalculateSwipePosition = shouldRecalculateSwipePosition, function (e) {
    return (e = void 0 === e ? 0 : e) < 0;
  }),
  getItemCoords = (exports.getIsLeftDirection = getIsLeftDirection, function (e, t) {
    return (t = void 0 === t ? [] : t).slice(e = void 0 === e ? 0 : e)[0] || {
      position: 0,
      width: 0
    };
  }),
  getSwipeShiftValue = (exports.getItemCoords = getItemCoords, function (e, t) {
    return void 0 === e && (e = 0), void 0 === t && (t = []), (0, exports.getItemCoords)(e, t).position;
  }),
  getTransformationItemIndex = (exports.getSwipeShiftValue = getSwipeShiftValue, function (e, t) {
    return void 0 === t && (t = 0), (e = void 0 === e ? [] : e).findIndex(function (e) {
      return e.position >= Math.abs(t);
    });
  }),
  getSwipeTransformationCursor = (exports.getTransformationItemIndex = getTransformationItemIndex, function (e, t, i) {
    void 0 === e && (e = []), void 0 === t && (t = 0), void 0 === i && (i = 0);
    e = (0, exports.getTransformationItemIndex)(e, t);
    return (0, exports.getIsLeftDirection)(i) ? e : e - 1;
  }),
  getSwipeTouchendPosition = (exports.getSwipeTransformationCursor = getSwipeTransformationCursor, function (e, t, i) {
    void 0 === i && (i = 0);
    var o = e.infinite,
      n = e.autoWidth,
      r = e.isStageContentPartial,
      s = e.swipeAllowedPositionMax,
      e = e.transformationSet,
      i = (0, exports.getSwipeTransformationCursor)(e, i, t),
      t = (0, exports.getItemCoords)(i, e).position;
    if (!o) {
      if (n && r) return 0;
      if (s < t) return -s;
    }
    return -t;
  }),
  getSwipeTouchendIndex = (exports.getSwipeTouchendPosition = getSwipeTouchendPosition, function (e, t) {
    var i = t.transformationSet,
      o = t.itemsInSlide,
      n = t.itemsOffset,
      r = t.itemsCount,
      s = t.infinite,
      d = t.isStageContentPartial,
      a = t.activeIndex,
      t = t.translate3d;
    return s || !d && t !== Math.abs(e) ? (d = (0, exports.getTransformationItemIndex)(i, e), s ? d < (t = (0, exports.getShiftIndex)(o, n)) ? r - o - n + d : t + r <= d ? d - (t + r) : d - t : d) : a;
  }),
  getFadeoutAnimationIndex = (exports.getSwipeTouchendIndex = getSwipeTouchendIndex, function (e) {
    var t = e.infinite,
      i = e.activeIndex,
      e = e.itemsInSlide;
    return t ? i + e : i;
  }),
  getFadeoutAnimationPosition = (exports.getFadeoutAnimationIndex = getFadeoutAnimationIndex, function (e, t) {
    var i = t.activeIndex,
      t = t.stageWidth;
    return e < i ? (i - e) * -t || 0 : (e - i) * t || 0;
  }),
  isVerticalTouchmoveDetected = (exports.getFadeoutAnimationPosition = getFadeoutAnimationPosition, function (e, t, i) {
    return e < (i = void 0 === i ? 0 : i) || e < .1 * t;
  });
exports.isVerticalTouchmoveDetected = isVerticalTouchmoveDetected;